import {
  FaCss3Alt,
  FaDocker,
  FaGitSquare,
  FaHtml5,
  FaNodeJs,
  FaPhp,
  FaReact,
} from 'react-icons/fa';
import {
  SiExpress,
  SiMysql,
  SiOracle,
  SiStyledcomponents,
  SiTailwindcss,
  SiTypescript,
} from 'react-icons/si';
import { RiNextjsFill } from 'react-icons/ri';

export const skillsData = [
  {
    title: 'Git',
    icon: <FaGitSquare />,
  },
  {
    title: 'HTML',
    icon: <FaHtml5 />,
  },
  {
    title: 'CSS',
    icon: <FaCss3Alt />,
  },
  {
    title: 'TypeScript',
    icon: <SiTypescript />,
  },
  {
    title: 'React',
    icon: <FaReact />,
  },
  {
    title: 'NEXT.js',
    icon: <RiNextjsFill />,
  },
  {
    title: 'Node.js',
    icon: <FaNodeJs />,
  },
  {
    title: 'Express.js',
    icon: <SiExpress />,
  },
  {
    title: 'PHP',
    icon: <FaPhp />,
  },
  {
    title: 'ORACLE',
    icon: <SiOracle />,
  },
  {
    title: 'MySQL',
    icon: <SiMysql />,
  },
  {
    title: 'Styled Components',
    icon: <SiStyledcomponents />,
  },
  {
    title: 'Tailwind CSS',
    icon: <SiTailwindcss />,
  },
  {
    title: 'Docker',
    icon: <FaDocker />,
  },
];
